import React from 'react';
import cn from 'classnames';

import Button from '../../../atoms/button/base-button';

import { ConfirmationTemplateProps } from './confirmation-template-props';
import styles from './confirmation-template.module.scss';

export function ConfirmationTemplate({
	children,
	actionsClass,

	title,
	TitleComponent = 'div',

	CancelButton = Button,
	cancel = 'Cancel',
	onCancel,

	ConfirmButton = Button,
	confirm = 'OK',
	onConfirm,
}: ConfirmationTemplateProps) {
	return (
		<>
			{title && <TitleComponent>{title}</TitleComponent>}
			{children}
			<div className={cn(styles.actions, actionsClass)}>
				{cancel && (
					<CancelButton onClick={onCancel} className="cancel-button">
						{cancel}
					</CancelButton>
				)}

				{confirm && (
					<ConfirmButton onClick={onConfirm} className="confirm-button" autoFocus>
						{confirm}
					</ConfirmButton>
				)}
			</div>
		</>
	);
}
